import RibbonsContainer from '../../Componant/BonusUI/Ribbons'

const Ribbons = () => {
  return (
    <div className="page-body">
        <RibbonsContainer/>
    </div>
  )
}

export default Ribbons